import React from 'react';
import { Checkbox as CheckBoxComponent } from '@alefeducation/ui-elements-library-core';

interface CheckBoxProps {
  children?: string;
  id?: string;
  value: string;
  checked?: boolean;

  onChange?(): void;
}

export const Checkbox = ({
  children,
  id,
  value,
  checked,
  onChange,
}: CheckBoxProps) => {
  return (
    <div className="checkbox">
      <CheckBoxComponent
        id={id}
        value={value}
        checked={checked}
        onChange={onChange}
        data-testid={`${value.toLowerCase().replace(/_/gi, '-')}-checkbox`}
      >
        {children}
      </CheckBoxComponent>
    </div>
  );
};
